export default __webpack_public_path__ + "static/media/thumbnail1.64c6f61d.jpg";